<template>
  <section class="mt-50 mb-50" id="blog-section">
    <div class="container">
      <div class="row justify-content-center mb-3 pb-3">
        <div class="col-md-10 text-center">
          <h2 class="mb-4">Our Blog</h2>
          <p>We’ve been at this for a decade. Let us share our expertise</p>
        </div>
      </div>
      <div class="row" v-if="loader">
        <div class="col loader">
          <div class="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="row d-flex" v-else>
        <div class="col-lg-4 col-md-6 col-sm-12 d-flex" v-for="(post) in allPost" :key="post.id">
          <div class="blog-entry blog_block justify-content-center">
            <div class="text">
              <h3 class="heading">{{post.topTitle}}</h3>
            </div>

            <img :src="post.img" alt class="block-20" style="object-fit: cover;" />

            <div class="text mt-3">
              <p class="text_heigth">{{post.summary}}</p>
              <div class="d-flex align-items-center mt-4 meta">
                <p class="mb-0">
                  <router-link :to="{name: 'Post', params:{id:post.id}}" class="btn btn-primary">
                    Read More
                    <i class="fas fa-arrow-right"></i>
                  </router-link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["allPost", "loader"])
  },
  async mounted() {
    await this.$store.dispatch("retrievePosts");
  }
};
</script>


<style lang="scss" scoped>
#blog-section {
  .blog_block {
    box-shadow: 0px 0px 25px -13px rgba(0, 0, 0, 0.75);
    margin: 10px 0;
    padding: 20px;
  }
  .heading {
    font-size: 18px;
    min-height: 65px;
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: auto;
  }
  .text_heigth {
    min-height: 150px;
  }
  img {
    width: 100%;
    height: 200px;
  }
}
</style>